import { render, staticRenderFns } from "./Diaporama_Photo.vue?vue&type=template&id=64a50f84&scoped=true&"
import script from "./Diaporama_Photo.vue?vue&type=script&lang=js&"
export * from "./Diaporama_Photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a50f84",
  null
  
)

export default component.exports